import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getSignature from 'utils/print/getSignature';
import getOrderLineDosFrom from 'utils/print/getOrderLineDosFrom';

const FootMeasurementEvaluationForm = {
  ID: 31,
  Name: 'Foot Measurement Evaluation Form',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Foot-Measurement-Evaluation-Form/1.js',
      Logo: {
        x: 5,
        y: 10,
        width: 35,
        height: 15,
      },
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 75,
          y: 15,
          width: 62,
        },
        {
          name: 'Patient DOB',
          type: 'text',
          getValue: getPatientFullDob,
          normalize: normalize.date,
          x: 173,
          y: 15,
          width: 32,
        },
        {
          name: 'Heel-to-Toe Left Foot',
          type: 'text',
          x: 55,
          y: 45,
          width: 27,
        },
        {
          name: 'Heel-to-Ball Left Foot',
          type: 'text',
          x: 88,
          y: 45,
          width: 27,
        },
        {
          name: 'Shoe Size Left Foot',
          type: 'text',
          x: 126,
          y: 45,
          width: 27,
        },
        {
          name: 'Width Left Foot',
          type: 'text',
          x: 163,
          y: 45,
          width: 27,
        },
        {
          name: 'Heel-to-Toe Right Foot',
          type: 'text',
          x: 55,
          y: 55,
          width: 27,
        },
        {
          name: 'Heel-to-Ball Right Foot',
          type: 'text',
          x: 88,
          y: 55,
          width: 27,
        },
        {
          name: 'Shoe Size Right Foot',
          type: 'text',
          x: 126,
          y: 55,
          width: 27,
        },
        {
          name: 'Width Right Foot',
          type: 'text',
          x: 163,
          y: 55,
          width: 27,
        },
        {
          name: 'Burning Pains',
          type: 'checkbox',
          x: 13,
          y: 78,
          width: 3,
          height: 3,
        },
        {
          name: 'Shooting Pains',
          type: 'checkbox',
          x: 13,
          y: 82,
          width: 3,
          height: 3,
        },
        {
          name: 'Numbness',
          type: 'checkbox',
          x: 13,
          y: 86,
          width: 3,
          height: 3,
        },
        {
          name: 'Other Patients Complaints',
          type: 'checkbox',
          x: 13,
          y: 91,
          width: 3,
          height: 3,
        },
        {
          name: 'Other Patients Complaints Text',
          type: 'text',
          x: 29,
          y: 90,
          width: 27,
        },
        {
          name: 'Callus',
          type: 'checkbox',
          x: 135,
          y: 78,
          width: 3,
          height: 3,
        },
        {
          name: 'Ulcer',
          type: 'checkbox',
          x: 135,
          y: 82,
          width: 3,
          height: 3,
        },
        {
          name: 'Pre-Ulcer',
          type: 'checkbox',
          x: 135,
          y: 86,
          width: 3,
          height: 3,
        },
        {
          name: 'Other Skin and Nails',
          type: 'checkbox',
          x: 135,
          y: 91,
          width: 3,
          height: 3,
        },
        {
          name: 'Other Skin and Nails Text',
          type: 'text',
          x: 150,
          y: 90,
          width: 27,
        },
        {
          name: 'Diabetics',
          type: 'checkbox',
          x: 179,
          y: 78,
          width: 3,
          height: 3,
        },
        {
          name: 'Amputation',
          type: 'checkbox',
          x: 179,
          y: 82,
          width: 3,
          height: 3,
        },
        {
          name: 'Ingrown Nail',
          type: 'checkbox',
          x: 179,
          y: 86,
          width: 3,
          height: 3,
        },
        {
          name: 'Pes Planus',
          type: 'checkbox',
          x: 13,
          y: 106.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Bunions',
          type: 'checkbox',
          x: 13,
          y: 110.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Hammer Toe',
          type: 'checkbox',
          x: 13,
          y: 114.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Acquired Deformities',
          type: 'checkbox',
          x: 13,
          y: 118.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Congenital Pes Cavus',
          type: 'checkbox',
          x: 13,
          y: 122.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Model',
          type: 'text',
          x: 147,
          y: 101,
          width: 47,
        },
        {
          name: 'Color',
          type: 'text',
          x: 147,
          y: 111,
          width: 47,
        },
        {
          name: 'Certified Pedorthist',
          type: 'text',
          x: 47,
          y: 131,
          width: 67,
        },
        {
          name: 'Date of Measurement',
          type: 'text',
          x: 178,
          y: 131,
          width: 36,
          normalize: normalize.date,
        },
        {
          name: 'Goals',
          type: 'text',
          x: 7,
          y: 170,
          width: 206,
          height: 24,
          multiline: true,
        },
        {
          name: 'Comments',
          type: 'text',
          x: 7,
          y: 201,
          width: 206,
          height: 24,
          multiline: true,
        },
        {
          name: 'I am completely satisfied with fitting services provided to me. The item tolerable to wear and appropriate as per physician prescription',
          type: 'checkbox',
          x: 6,
          y: 230,
          width: 3,
          height: 3,
        },
        {
          name: 'I was recommended to come for follow-up visit 2-3 weeks later',
          type: 'checkbox',
          x: 6.5,
          y: 245,
          width: 3,
          height: 3,
        },
        {
          name: 'Patient used shoes in office',
          type: 'checkbox',
          x: 6.5,
          y: 255.5,
          width: 3,
          height: 3,
        },
        {
          name: 'Patient used shoes in office Text',
          type: 'text',
          x: 59,
          y: 253,
          width: 12,
          normalize: normalize.positiveNumber,
        },
        {
          name: 'Ive received the copy of',
          type: 'checkbox',
          x: 130,
          y: 230,
          width: 3,
          height: 3,
        },
        {
          name: 'Shoes Perfectly Fit',
          type: 'checkbox',
          x: 130,
          y: 245,
          width: 3,
          height: 3,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 35,
          y: 259,
          width: 75,
          height: 10,
        },
        {
          name: 'Date of Service',
          type: 'text',
          getValue: props => getOrderLineDosFrom({ ...props, index: 0 }),
          normalize: normalize.date,
          x: 175,
          y: 264,
          width: 35,
        },
      ],
    },
  ],
};

export default FootMeasurementEvaluationForm;



// WEBPACK FOOTER //
// ./src/config/documents/Foot-Measurement-Evaluation-Form.js